<template>
  <el-dialog
    :title="title"
    :visible.sync="innerVisible"
    width="870px"
    height="400px"
  >
    <cargo-ag-grid
      :grid-options="chargeGrid.gridOptions"
      :column-defs="chargeGrid.columnDefs"
      :grid-params.sync="chargeGrid.gridParams"
      :row-data="chargeGrid.rowData"
      style="width:100%;height:400px;"
      @gridReady="onGridReady"
    />
  </el-dialog>
</template>

<script>
import { getClearHistory } from '@/api/clearing/charge'
import DateUtils from '@/utils/dateUtils'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { formatNumberToThousands } from '@/utils'

export default {
  name: 'VerifiedDialog',
  props: {
    visible: { type: Boolean, required: true },
    charge: { type: Object, required: true }
  },
  data() {
    return {
      innerVisible: false,
      title: this.$t('SeaExport.VerificationSchedule'),
      chargeGrid: {
        gridParams: {},
        gridOptions: {
          rowSelection: 'multiple',
          suppressCellSelection: true,
          defaultColDef: {
            resizable: true,
            filter: true
          },
          pagination: false
        },
        gridApi: null,
        columnDefs: [
          {
            headerName: this.$t('SeaExport.ClearingDate'),
            field: 'clearingDate',
            width: 100,
            cellRenderer: (params) => {
              return DateUtils.formatStandardDate(this.charge.clearingDate)
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_PayReceiveDate'),
            field: 'payReceiveDate',
            width: 100,
            cellRenderer: (params) => {
              return DateUtils.formatStandardDate(params.value)
            }
          },
          {
            headerName: this.$t('SeaExport.VerificationBy'),
            field: 'verificationBy',
            width: 100,
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_WriteOffCurrency'),
            field: 'actualCurrency',
            width: 100,
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Currency, 'code', params.value, 'code')
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_WriteOffRate'),
            field: 'clearRate',
            width: 100,
            cellRenderer: (params) => {
              return formatNumberToThousands(ColumnUtils.roundHalfUp(params.value, 6))
            }
          },
          {
            headerName: this.$t('Payment.theAmountOfWriteOffs'),
            field: 'actualAmt',
            width: 100,
            cellRenderer: (params) => {
              return formatNumberToThousands(ColumnUtils.roundHalfUp(params.value, 2))
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_VoucherNo'),
            field: 'voucherNo',
            width: 100
          },
          {
            headerName: this.$t('CargoMsg.Cargo_PaymentMethod'),
            field: 'type',
            width: 100,
            cellRenderer: (params) => {
              return this.typeLabelFunc(params.value)
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_OurBank'),
            field: 'ourBank',
            width: 100
          }
        ],
        rowData: []
      }
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
    },
    innerVisible(newVal) {
      if (!newVal) {
        this.chargeGrid.rowData = []
        this.$emit('cancel')
      } else {
        this.searchVerified(this.charge.uuid)
      }
    }
  },
  methods: {
    onGridReady(params) {
      this.chargeGrid.gridApi = params.api
    },
    // 查询费用核销历史
    searchVerified(chargeUuid) {
      getClearHistory(chargeUuid).then(res => {
        this.chargeGrid.rowData = res.data
      })
    },
    typeLabelFunc(val) {
      if (val === 0) {
        return this.$t('SeaExport.Cash')
      } else if (val === 1) {
        return this.$t('SeaExport.Check')
      } else {
        return this.$t('SeaExport.Transfer')
      }
    }
  }
}
</script>

<style scoped>

</style>
